export interface IUsersConsultationLogDatatable {
  login: string;
  username: string;
  menuOption: string;
  accessType: string;
  date: string;
  time: string;
}

const columns = () => [
  {
    id: 'login',
    header: 'Login',
    accessorKey: 'login',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'username',
    header: 'Username',
    accessorKey: 'username',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'menuOption',
    header: 'Menu Option',
    accessorKey: 'menuOption',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'date',
    header: 'Date',
    accessorKey: 'date',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'time',
    header: 'Time',
    accessorKey: 'time',
    cell: (ctx: any) => ctx.getValue(),
  },
];

export const UsersConsultationLogDatatable = {
  columns,
};
